import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiAddServer, Server, UpdateServer } from '../../shared/models/server.models';

@Injectable({
  providedIn: 'root',
})
export class ServersService {
  private http = inject(HttpClient);

  addServer(addServerDto: ApiAddServer): Observable<void> {
    return this.http.post<void>('/cloud-management/servers', addServerDto);
  }

  getAllServers(): Observable<Server[]> {
    return this.http.get<Server[]>('/cloud-management/servers');
  }

  getServerTypes(): Observable<string[]> {
    return this.http.get<string[]>('/cloud-management/servers-types');
  }

  getServerTypeServices(type: string): Observable<string[]> {
    return this.http.get<string[]>(`/cloud-management/server-types/${type}/services`);
  }

  getServersOfType(type: string): Observable<Server[]> {
    return this.http.get<Server[]>(`/cloud-management/servers?type=${type}`);
  }

  getServersByIds(ids: string[]): Observable<Server[]> {
    const queryString = ids.map((id) => `ids[]=${id}`).join('&');
    return this.http.get<Server[]>('/cloud-management/servers' + '?' + queryString);
  }

  removeServer(serverId: string): Observable<void> {
    return this.http.delete<void>(`/cloud-management/servers/${serverId}`);
  }

  getServer(id: string): Observable<Server> {
    return this.http.get<Server>(`/cloud-management/servers/view/${id}`);
  }

  updateServerStatus(hostname: string, status: string): Observable<void> {
    return this.http.patch<void>(`/cloud-management/servers/${hostname}/status`, { status });
  }

  updateServerById(serverId: string, data: UpdateServer): Observable<void> {
    return this.http.patch<void>(`/cloud-management/servers/${serverId}`, data);
  }
}
